import { Avatar, Box, List, ListItemButton, ListItemText, Typography } from "@mui/material";
import { capabilities, type CapabilityKey } from "./investorPortalCapabilities";

interface Props {
  activeKey: CapabilityKey;
  onSelect: (key: CapabilityKey) => void;
}

const CapabilitiesNav = ({ activeKey, onSelect }: Props) => (
  <Box component="nav" aria-label="Capabilities" sx={{ width: 256, flexShrink: 0, position: "sticky", top: 24 }}>
    <Typography variant="subtitle1" component="h2" sx={{ px: 2, pt: 0.5 }}>
      Capabilities
    </Typography>
    <List component="div">
      {capabilities.map(({ key, Icon, title, subtitle }) => {
        const isActive = key === activeKey;
        return (
          <ListItemButton key={key} selected={isActive} onClick={() => onSelect(key)} sx={{ px: 1, py: 0.5 }}>
            <Avatar
              variant="rounded"
              sx={[
                { width: 32, height: 32, mr: 1.5 },
                isActive && { bgcolor: "primary.main", color: "primary.contrastText" },
              ]}
            >
              <Icon />
            </Avatar>
            <ListItemText
              primary={title}
              secondary={subtitle}
              slotProps={{ primary: { variant: "subtitle2", component: "span" } }}
            />
          </ListItemButton>
        );
      })}
    </List>
  </Box>
);

export default CapabilitiesNav;
